import { HandledError } from "./errors"
import { RestError } from "./errors/rest-error"
import { alertDisplay } from "./errors/text"

export function isHandledError(e: unknown): e is HandledError {
  return e instanceof HandledError
}

export function isRestError(e: unknown): e is RestError {
  return e instanceof RestError
}

export function getGenericAlert() {
  return alertDisplay.generic
}

export function getRateLimitAlert() {
  return alertDisplay.restError.byFailure["Rate limited"]
}
